import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Navbarsticky from "./NavbarSticky";
import { useSelector } from "react-redux";

import { useDispatch } from "react-redux";
import { register } from "../store/slices/auth";

export default function Signup() {
  const loading = useSelector((state) => state.auth.loading);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    mobilenumber: "",
    address: "",
    terms: false,
  });
  const [errors, setErrors] = useState({});

  const validateField = (name, value, form) => {
    switch (name) {
      case "name":
        if (!value.trim()) return "Please enter your name";
        return "";

      case "email":
        if (!value) return "Please enter your email";
        if (!/^\S+@\S+\.\S+$/.test(value)) return "Please enter a valid email";
        return "";

      case "mobilenumber":
        if (!value) return "Please enter your mobile number";
        if (!/^\d*$/.test(value)) return "Only numbers allowed";
        if (value.length !== 10) return "Phone number must be 10 digits";
        return "";

      case "address":
        if (!value.trim()) return "Please enter your address";
        return "";

      case "terms":
        if (!value) return "You must agree to the Terms & Conditions";
        return "";

      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setForm((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));

    // live validation
    const error = validateField(name, fieldValue, {
      ...form,
      [name]: fieldValue,
    });

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // form validation
  const validate = () => {
    const newErrors = {};

    Object.keys(form).forEach((key) => {
      const error = validateField(key, form[key], form);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // register form details in Api
  const handleSubmit = (e) => {
    e.preventDefault();

    if (loading) return;
    if (!validate()) return;

    const payload = {
      name: form.name,
      email: form.email,
      mobileNumber: form.mobilenumber,
      address: form.address,
    };

    dispatch(register(payload))
      .unwrap()
      .then(() => {
        //  persist for OTP page (refresh-safe)
        sessionStorage.setItem("otp_signup_email", form.email);
        sessionStorage.setItem("otp_signup_mobile", form.mobilenumber);

        navigate("/verifyOtp", {
          state: {
            email: form.email,
            mobileNumber: form.mobilenumber,
          },
        });
      })
      .catch((err) => {
        alert(err || "Registration Failed");
      });
  };

  return (
    <>
      {/* navbar */}
      <Navbarsticky />
      <div className="auth-container"></div>
      <div className="auth-page">
        <div className="auth-card">
          {/* left img */}
          <div className="auth-left">
            <div className="auth-left-top">
              <span className="auth-logo-text">ANDAMAN MAKE HOLIDAYS</span>
            </div>
          </div>

          {/* right form */}
          <div className="auth-form-wrapper">
            <div className="auth-form-header">
              <h1>Create an account</h1>
              <p>
                Already have an account?{" "}
                <Link to="/login" className="auth-link">
                  Log in
                </Link>
              </p>
            </div>

            <form className="auth-form" onSubmit={handleSubmit} noValidate>
              <div className="auth-input-group">
                <label htmlFor="name">Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter your name"
                  value={form.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <span className="auth-error-text">{errors.name}</span>
                )}
              </div>

              <div className="auth-input-group full">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <span className="auth-error-text">{errors.email}</span>
                )}
              </div>

              <div className="auth-input-group full">
                <label htmlFor="mobilenumber">Phone Number</label>
                <input
                  id="mobilenumber"
                  name="mobilenumber"
                  type="tel"
                  placeholder="Enter your mobile number"
                  value={form.mobilenumber}
                  onChange={handleChange}
                />
                {errors.mobilenumber && (
                  <span className="auth-error-text">{errors.mobilenumber}</span>
                )}
              </div>

              <div className="auth-input-group full">
                <label htmlFor="address">Address</label>
                <input
                  id="address"
                  name="address"
                  type="text"
                  placeholder="Enter your address"
                  value={form.address}
                  onChange={handleChange}
                />
                {errors.address && (
                  <span className="auth-error-text">{errors.address}</span>
                )}
              </div>

              <div className="auth-row">
                <label className="auth-checkbox">
                  <input
                    type="checkbox"
                    name="terms"
                    checked={form.terms}
                    onChange={handleChange}
                  />
                  <span>
                    I agree to the{" "}
                    <button type="button" className="auth-text-btn inline">
                      <Link to="/terms-conditions">Terms &amp; Conditions</Link>
                    </button>
                  </span>
                </label>
              </div>
              {errors.terms && (
                <span className="auth-error-text">{errors.terms}</span>
              )}

              <button
                type="submit"
                className="auth-primary-btn"
                disabled={loading}
              >
                {loading ? "Registering..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </>
  );
}
